import React from "react";

// Libraries
import { animated } from "react-spring";

function CardRange({ title, description, style, image }) {
    return (
        <animated.div style={style} className="card">
            <div
                className="card-question flex flex-center shadow-xl relative img-background"
                style={{
                    backgroundImage: `url('${process.env.PUBLIC_URL}/icons/${image}')`,
                }}
            >
                {title && <h3 className="fs-l">{title}</h3>}
                {description && <p className="fs-m">{description}</p>}
            </div>
        </animated.div>
    );
}

export default CardRange;
